import React from 'react'
import PropTypes from 'prop-types'

import Review from './Review'
import styles from './styles.scss'

const Reviews = (props) => {
  const { campaigns, reviews } = props

  return (
    <div className={styles.root}>
      <h4>Recent Testimonials</h4>

      {reviews.map((review, index) => {
        const campaign = campaigns[review.subject_id] || {}
        return (
          <Review key={review.id} campaign={campaign} large={index <= 2} review={review} />
        )
      })}
    </div>
  )
}

Reviews.propTypes = {
  campaigns: PropTypes.object.isRequired,
  reviews: PropTypes.array.isRequired,
}

export default Reviews
